import axios from "axios";
import { APIConstants, APILimit } from "../../constants/ApiConstants";

export const getPhysicalVouchers = async (filters: string) => {
  let baseURl = `${process.env.REACT_APP_API_URL}${APIConstants.getAllPhysicalVoucher}${APILimit}`;
  if (filters) {
    baseURl += (baseURl.includes("?") ? "&" : "?") + `${filters}`;
  }
  const response = await axios.post(baseURl);
  return response?.data;
};

export const getVouchers = async (filters: string) => {
  let baseURl = `${process.env.REACT_APP_API_URL}${APIConstants.getAllReimbursementEvoucher}${APILimit}`;
  if (filters) {
    baseURl += (baseURl.includes("?") ? "&" : "?") + `${filters}`;
  }
  const response = await axios.get(baseURl);
  return response?.data;
};
export const bulkUpload = async (file: any) => {
  const baseURl = `${process.env.REACT_APP_API_URL}bulkUpload`;
  const response = await axios.post(baseURl, file, {
    headers: {
      "Content-Type": "multipart/form-data",
      noToken: true,
    },
  });
  
  return response?.data;
};

export const getInvalidCsvFile = async (filename: string) => {
  let baseURl = `${process.env.REACT_APP_API_URL}${APIConstants.download}?key=${filename}`;
  const response = await axios.get(baseURl);
  return response?.data;
};


